import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";

const HonoraryMembershipServiceApi = createApi({
    reducerPath: 'HonoraryMembershipServiceApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
       
        //Mutation to create new Honorary Member
        createHonoraryMemberDetails: builder.mutation({
            query: (details) => ({
                url: `/Membership/CreateHonoraryMemberDetails`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})

export const {
    useCreateHonoraryMemberDetailsMutation,
} = HonoraryMembershipServiceApi;

export default HonoraryMembershipServiceApi;